import cn from "classnames";
import CopyCoordinates from "components/shared/copyCoordinates";
import DropdownBtn from "components/shared/dropdown";
import { formatDateTimezone } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { bidRefuelingServiceTypesEnum, gasStationTypes, gasStationTypesEnum } from "helpers/enums";
import { formatNumber } from "helpers/system";
import Tooltip from "rc-tooltip";
import React from "react";
import { deleteRefueling } from "sources/books/refueling";

const PointRefueling = (props) => {
    const {
        id,
        bidId,
        mapObject,
        name,
        fuelName,
        mergeMapViewport,
        requiredLoadVolume,
        trailerRefueling,
        canEditPlanRefuelings,
        modal,
        getItem,
        price,
        priceWithDiscount,
        nextPoint,
        fuelCards,
        resource,
        gasStationType,
        refuelingServiceType,
        estimatedDate,
        autoEnteredAt,
        autoLeftAt,
        organization,
    } = props;

    const completedRoute = () => {
        if (!autoEnteredAt || !nextPoint) {
            return null;
        }
        if (autoEnteredAt && !autoLeftAt) {
            return null;
        }

        const height =
            nextPoint.enteredAt || nextPoint.autoEnteredAt || nextPoint.enteredAtByLogist || nextPoint.manualStartAt
                ? 100
                : 50;
        return (
            <>
                <div className="b-timeline-point__line--green" style={{ height: `${height}%` }} />
                {!(
                    nextPoint.enteredAt ||
                    nextPoint.autoEnteredAt ||
                    nextPoint.enteredAtByLogist ||
                    nextPoint.manualStartAt
                ) && <div className="b-timeline-point__line--car" />}
            </>
        );
    };

    const circleCnames = cn("b-timeline-point__circle", { "b-timeline-point__circle--green": autoEnteredAt });

    const renderFuelCard = (card, index) => {
        return (
            <div className="b-timeline-point__fuel-card" key={index}>
                {card.hasCardsConflict && (
                    <Tooltip placement="right" overlay="Конфликт по топливным картам">
                        <div className="b-timeline-point__fuel-card--has-conflict" />
                    </Tooltip>
                )}
                <img
                    src={card.iconUrl}
                    key={index}
                    className="b-timeline-point__fuel-card--img"
                    alt={card.brand || ""}
                />
                <div className="b-timeline-point__fuel-card--text">
                    {card.brand}
                    {card.number && (
                        <>
                            <br />
                            <small>Номер карты: {card.number}</small>
                        </>
                    )}
                </div>
            </div>
        );
    };

    const renderPriceWithDiscount = () => {
        if (!priceWithDiscount) {
            return null;
        }

        return (
            <>
                <div className="b-timeline-point__date--name">Стоимость со скидкой</div>
                <div className="b-timeline-point__date--value">
                    {formatNumber(priceWithDiscount, { style: "currency", currency: organization?.currency })}
                </div>
            </>
        );
    };

    const renderMultiGoFuelIcon = () => {
        return (
            resource &&
            resource.iconUrl && (
                <img
                    src={resource.iconUrl}
                    className="b-timeline-point__circle--refueling-logo"
                    alt={resource.name || ""}
                />
            )
        );
    };

    const renderDefaultFuelIcon = () => {
        if (gasStationType !== gasStationTypesEnum.Rosneft) {
            return null;
        }

        return (
            <img
                src="/images/refuelings/rosneft.png"
                className="b-timeline-point__circle--refueling-logo"
                alt="Роснефть"
            />
        );
    };

    const renderFuelIcon = () => {
        const className = cn("b-timeline-point__circle--text", {
            "b-timeline-point__circle--refueling": [
                bidRefuelingServiceTypesEnum.MultiGo,
                bidRefuelingServiceTypesEnum.MultiGo2,
                bidRefuelingServiceTypesEnum.SolarFrps,
            ].includes(refuelingServiceType)
                ? !resource || !resource.iconUrl
                : gasStationType === gasStationTypesEnum.Unknown,
        });

        return (
            <div className={className}>
                {[
                    bidRefuelingServiceTypesEnum.MultiGo,
                    bidRefuelingServiceTypesEnum.MultiGo2,
                    bidRefuelingServiceTypesEnum.SolarFrps,
                ].includes(refuelingServiceType)
                    ? renderMultiGoFuelIcon()
                    : renderDefaultFuelIcon()}
            </div>
        );
    };

    const renderFuelName = () => {
        if (
            [
                bidRefuelingServiceTypesEnum.MultiGo,
                bidRefuelingServiceTypesEnum.MultiGo2,
                bidRefuelingServiceTypesEnum.SolarFrps,
            ].includes(refuelingServiceType)
        ) {
            return name;
        } else {
            const gasStationLabel = gasStationTypes.find((item) => gasStationType === item.value).label;

            return gasStationLabel;
        }
    };

    const renderVolumeInfo = ({
        requiredLoadVolume,
        planVolumeBeforeRefueling,
        factVolumeBeforeRefueling,
        planVolumeAfterRefueling,
        factVolumeAfterRefueling,
        factLoadVolume,
    }) => {
        return (
            <>
                <div className="b-timeline-point__date--name">Топливо</div>
                <div className="b-timeline-point__date--value">
                    {fuelName}, {formatNumber(Math.round(requiredLoadVolume))} л.
                </div>
                <div className="b-timeline-point__date--name">Кол-во топлива до заправки (план)</div>
                <div className="b-timeline-point__date--value">
                    {formatNumber(Math.round(planVolumeBeforeRefueling))} л.
                </div>
                {factVolumeBeforeRefueling && (
                    <>
                        <div className="b-timeline-point__date--name">Кол-во топлива до заправки (факт)</div>
                        <div className="b-timeline-point__date--value">
                            {formatNumber(Math.round(factVolumeBeforeRefueling))} л.
                        </div>
                    </>
                )}
                <div className="b-timeline-point__date--name">Кол-во топлива после заправки (план)</div>
                <div className="b-timeline-point__date--value">
                    {formatNumber(Math.round(planVolumeAfterRefueling))} л.
                </div>
                {factVolumeAfterRefueling && (
                    <>
                        <div className="b-timeline-point__date--name">Кол-во топлива после заправки (факт)</div>
                        <div className="b-timeline-point__date--value">
                            {formatNumber(Math.round(factVolumeAfterRefueling))} л.
                        </div>
                    </>
                )}
                {factLoadVolume && (
                    <>
                        <div className="b-timeline-point__date--name">Заправлено топлива по факту</div>
                        <div className="b-timeline-point__date--value">
                            {formatNumber(Math.round(factLoadVolume))} л.
                        </div>
                    </>
                )}
            </>
        );
    };

    const editBtn = () => {
        if (autoEnteredAt || !canEditPlanRefuelings) {
            return null;
        }
        const items = [
            {
                text: "Редактировать заправку",
                action: () =>
                    modal({
                        name: "editPlanRefueling",
                        bidId,
                        carRequiredLoadVolume: requiredLoadVolume,
                        trailerRequiredLoadVolume: trailerRefueling?.requiredLoadVolume,
                        refuelingId: id,
                        title: "Редактировать заправку",
                        callback: (success) => success && getItem(),
                    }),
            },
            {
                text: "Удалить заправку",
                action: () => {
                    return modal({
                        name: "confirm",
                        title: "Удалить заправку",
                        text: "Вы уверены, что хотите удалить заправку?",
                        buttons: { confirm: "Да", cancel: "Нет" },
                        action: () => {
                            deleteRefueling({ bidId, id }).then(() => getItem());
                        },
                    });
                },
            },
        ];

        const props = {
            withoutChevron: true,
            text: <i className="icon-uEA10-pen" />,
            cname: "b-timeline-point__settings",
            align: "end",
            wrapCname: "b-timeline-point__settings--wrap",
            items,
        };
        return (
            <div className="b-timeline-point__city--type-wrap c-dropd">
                <DropdownBtn {...props} />
            </div>
        );
    };

    const utcTimezone = formatDateTimezone({ planEnterDateOffset: autoEnteredAt });

    return (
        <div className="b-timeline-point">
            <div className="b-timeline-point__figure">
                <div className={circleCnames}>{renderFuelIcon()}</div>
                <div className="b-timeline-point__line">{completedRoute()}</div>
            </div>
            <div className="b-timeline-point__data">
                <div className="b-timeline-point__city">
                    <div className="pb-1 b-timeline-point__city--info">
                        <div>
                            <span
                                className="b-timeline-point__city--name"
                                onClick={() =>
                                    mergeMapViewport({
                                        center: [...mapObject.location.coordinates].reverse(),
                                        zoom: 12,
                                    })
                                }
                            >
                                {renderFuelName()}
                            </span>
                            <small className="b-timeline-point__city--timezone">&nbsp;{utcTimezone}</small>
                        </div>
                        {editBtn()}
                    </div>
                    <div className="b-timeline-point__city--full">
                        <CopyCoordinates coordinates={[...mapObject.location.coordinates].reverse().join(", ")} />
                        {mapObject.address}
                    </div>
                </div>
                <div className="b-timeline-point__info pb-3">
                    <div className="b-timeline-point__table b-timeline-point__table--double-column">
                        <div className="b-timeline-point__date--name">Стоимость</div>
                        <div className="b-timeline-point__date--value">
                            {formatNumber(price, { style: "currency", currency: organization?.currency })}
                        </div>
                        {renderPriceWithDiscount()}
                        {estimatedDate && (
                            <>
                                <div className="b-timeline-point__date--name">Расчетная дата въезда</div>
                                <div className="b-timeline-point__date--value">{dateTimeToView(estimatedDate)}</div>
                            </>
                        )}
                        {autoEnteredAt && (
                            <>
                                <div className="b-timeline-point__date--name">Время въезда по GPS</div>
                                <div className="b-timeline-point__date--value">{dateTimeToView(autoEnteredAt)}</div>
                            </>
                        )}
                        {autoLeftAt && (
                            <>
                                <div className="b-timeline-point__date--name">Время выезда по GPS</div>
                                <div className="b-timeline-point__date--value">{dateTimeToView(autoLeftAt)}</div>
                            </>
                        )}
                        {!!requiredLoadVolume && (
                            <>
                                <div className="b-timeline-point__table--row font-size-14 font-weight-bold pt-2">
                                    Машина
                                </div>
                                {renderVolumeInfo(props)}
                            </>
                        )}
                        {trailerRefueling && (
                            <>
                                <div className="b-timeline-point__table--row font-size-14 font-weight-bold pt-2">
                                    Прицеп
                                </div>
                                {renderVolumeInfo(trailerRefueling)}
                            </>
                        )}
                    </div>
                </div>
                {(fuelCards || []).map(renderFuelCard)}
            </div>
        </div>
    );
};

export default PointRefueling;
